<template>
  <div class="container">
    <div class="header">
      <div v-for="item in labelConfig" :key="item.key + item.labelName" :style="`width:${item.width};`" class="label-wrapper">
        <span class="label-name">{{ item.labelName }}:</span>
        <a-tooltip>
          <div slot="title" v-html="labelInfo[item.key]"></div>
          <component :is="item.clickEvent ? 'a' : 'div'" class="label-value" v-html="labelInfo[item.key]" @click="click(item.clickEvent)"></component>
        </a-tooltip>
      </div>
    </div>
    <template>
      <div class="content-wrapper" :style="!isunfold ? `max-height: ${clampHeight}px` : ''">
        <div class="content">
          <div ref="content">
            <slot></slot>
          </div>
        </div>
      </div>
      <div class="extend">
        <div v-if="clampHeight < contentHeight">
          <a v-if="!isunfold" @click="clickUnfould"> 展开<a-icon type="down" /> </a>
          <a v-if="isunfold" @click="clickUnfould"> 收起<a-icon type="up" /> </a>
        </div>
      </div>
    </template>
    <a-divider v-if="showDivider" class="divider-custom" />
  </div>
</template>
<script>
export default {
  props: {
    labelConfig: {
      type: Array,
      default() {
        return [
          {
            key: '',
            clickEvent: '',
            labelName: '',
            width: '25%'
          }
        ];
      }
    },
    labelInfo: {
      type: Object,
      default() {
        return {};
      }
    },
    content: {
      type: String,
      default: ''
    },
    clampHeight: {
      type: Number,
      default: 134
    },
    showDivider: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isunfold: false,
      contentHeight: 0
    };
  },
  mounted() {
    this.contentHeight = this.$refs.content.offsetHeight;
  },
  methods: {
    click(eventName) {
      if (!eventName) return;
      this.$emit(eventName);
    },
    clickUnfould() {
      this.isunfold = !this.isunfold;
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  margin: 0 8px;
  /deep/.ant-divider {
    margin: 16px 0 8px 0;
  }
}
.header {
  display: flex;
  flex-wrap: wrap;
}
.label-wrapper {
  display: flex;
  margin: 4px 0;
}
.label-name {
  color: rgba(0, 0, 0, 0.45);
  white-space: nowrap;
  margin-right: 8px;
}
.label-value {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 4px;
  font-weight: 500;
}
.content-wrapper {
  margin-top: 5px;
  padding: 8px 12px 0px 12px;
  background-color: rgb(248, 248, 248);
  border-radius: 4px 4px 0 0;

  width: 100%;
  line-height: 24px;
  overflow-x: auto;
  overflow-y: hidden;
  position: relative;
  font-size: 13px;
  display: flex;
  .content {
    overflow: hidden;
    flex: 1;
  }
}
.extend {
  padding: 0 12px 8px 12px;
  font-size: 13px;
  background-color: rgb(248, 248, 248);
  border-radius: 0 0 4px 4px;

  a,
  i,
  span {
    font-size: 13px;
    padding: 0;
  }
  i {
    margin-left: 4px;
  }
}
</style>
